document.addEventListener("DOMContentLoaded", () => {

  const drawer = document.getElementById("todays-offers-drawer");

  if (!drawer) return;

  const openButtons = document.querySelectorAll("[data-open-offers]");
  const closeButtons = document.querySelectorAll("[data-close-drawer]");

  function openDrawer() {
    drawer.classList.add("active");
    document.documentElement.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    document.documentElement.style.overflow = "";
  }

  openButtons.forEach(button => {
    button.addEventListener("click", openDrawer);
  });

  closeButtons.forEach(button => {
    button.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer();
    }
  });

});